import contractorsApiService from '@/services/api/Contractors'

const emptyModel = {
  id: null,
  name: null,
  contact_details: {
    address: null,
    city: null,
    phone: null,
    email: null,
    first_name: null,
    last_name: null
  },
  type: null,
  description: null,
  country_id: null,
  trucking_duration: null,
  equipment_installing_duration: null,
  final_delivery_durations: [],
  yacht_manufacturer_id: null
}

const emptyFilters = {
  name: null,
  country: null,
  manufacturer: null
}

export const TYPE_SUPPLIER = 'supplier'
export const TYPE_YARD = 'yard'
export const TYPE_TRUCKING = 'trucking'
export const TYPE_SERVICE = 'service'
export const TYPE_OTHER = 'other'

const TYPE_DATA = [
  {
    key: TYPE_SUPPLIER,
    label: 'Supplier'
  },
  {
    key: TYPE_YARD,
    label: 'Commissioning Yard'
  },
  {
    key: TYPE_TRUCKING,
    label: 'Trucking Company'
  },
  {
    key: TYPE_SERVICE,
    label: 'Service Station'
  },
  {
    key: TYPE_OTHER,
    label: 'Other'
  }
]

export default class Contractor {
  static api = contractorsApiService
  static emptyFilters = emptyFilters
  static emptyModel = emptyModel

  static TYPE_SUPPLIER = TYPE_SUPPLIER
  static TYPE_YARD = TYPE_YARD
  static TYPE_TRUCKING = TYPE_TRUCKING
  static TYPE_SERVICE = TYPE_SERVICE
  static TYPE_OTHER = TYPE_OTHER

  static typeData = TYPE_DATA
}
